module.exports = __webpack_public_path__ + "img/product-shot_02_loading.1bf3e379.jpg";